import React from "react";
import { useBrowserPageTitle } from "../../../components/BrowserPageTitle/BrowserPageTitle";
import { FilterableTablePayables } from "../components/TablePayables/FilterableTablePayables";

export const RoutePayablesPaid: React.FC = () => {
  useBrowserPageTitle("Paid Payables");

  return (
    <FilterableTablePayables
      tab="paid"
      showDownloadCsv
      visibleColumns={{
        payee: true,
        payableNumber: true,
        amount: true,
        paidAt: true,
        status: true
      }}
      visibleFilters={{
        payeeId: true,
        paidDateRange: true,
        dueDateRange: true,
        bulkBatchId: true
      }}
      emptyState={{
        firstTime: "All of your sent payables will be shown here.",
        standart: "No paid payables."
      }}
    />
  );
};
